export default function loadScript(scriptSrc, attributes = {}) {
  const otherScript = document.getElementsByTagName('script')[0];
  const newScript = document.createElement('script');
  if (attributes.defer) {
    newScript.defer = attributes.defer;
    delete attributes.defer;
  } else {
    newScript.async = true;
  }
  newScript.src = scriptSrc;
  newScript.onload = attributes.onload;
  delete attributes.onload;
  newScript.onerror = attributes.onerror;
  delete attributes.onerror;
  Object.keys(attributes).forEach(key => {
    newScript.setAttribute(key, attributes[key]);
  });
  if (otherScript && otherScript.parentNode) {
    otherScript.parentNode.insertBefore(newScript, otherScript);
  } else {
    /* no op, to FIX, otherScript could be null */
  }
}